import logoYandex from '../assets/images/payment-providers/yandex.png';
import logoPayu from '../assets/images/payment-providers/payu.png';
import logoRobokassa from '../assets/images/payment-providers/robokassa.png';
import SUPPLIES from './routing/supplies';

export const DOMAIN = process.env.REACT_APP_DOMAIN || 'app-cn.kak2c.ru';
export const HOST = `https://${DOMAIN}`;
export const SHOWCASE_HOST =
  process.env.REACT_APP_SHOWCASE_HOST || 'http://v2-test.{{host}}.kak2c.ru';

export const UNAUTH_MAIN_PAGE = '/sign_in';

export const UNAUTH_PATHS = [
  '/sign_in',
  '/sign_up',
  '/forgot',
  '/password-recovery',
  '/json-table',
];

export const ITEMS_COUNT_ON_PAGE = 15;
export const ORDERS_COUNT_ON_PAGE = 15;
export const SHIPPINGS_COUNT_ON_PAGE = 15;
export const SUPPLIES_COUNT_ON_PAGE = 15;
export const COUNTRAGENTS_COUNT_ON_PAGE = 10;
export const TICKETS_COUNT_ON_PAGE = 10;
export const PROMOCODES_COUNT_ON_PAGE = 10;
export const REVIEWS_COUNT_ON_PAGE = 10;
export const PRODUCT_JOURNAL_ON_PAGE = 15;
export const FEEDS_COUNT_ON_PAGE = 10;
export const USERS_SETTINGS_COUNT_ON_PAGE = 5;
export const BILL_DOCS_COUNT_ON_PAGE = 15;

export const PER_PAGE_SELECT_OPTIONS = [
  { value: 5, label: 5 },
  { value: 15, label: 15 },
  { value: 30, label: 30 },
  { value: 50, label: 50 },
];

export const ITEMS_TABLE_THEAD = [
  { id: 'shortname', title: 'Наименование' },
  { id: 'article', title: 'Артикул' },
  { id: 'barcode', title: 'Штрихкод', unsorted: true },
  { id: 'price', title: 'Цена' },
  {
    id: 'amount',
    title: 'Доступно',
    description:
      'Отображается доступное к продаже количество, за минусом зарезервированного под заказы',
  },
];

export const INFO_STATUS_BAR_TRANSLATE = {
  ORDER_INFO_DRAFT: 'Черновик',
  ORDER_INFO_NEW: 'Новый',
  ORDER_INFO_NEED_CONFIRM: 'Не подтвержден',
  ORDER_INFO_INSUFFICIENT_RESERVE: 'Не хватает товара',
  ORDER_INFO_REQUIRE_PAYMENT: 'Ожидает оплаты',
  ORDER_INFO_READY_TO_PACK: 'Готов к комплектации',
  ORDER_INFO_CONFIRM_HOLD: 'Перезвонить',
  ORDER_INFO_PACKED: 'Упакован',
  ORDER_INFO_PACKED_DOCUMENTS_REQUIRED: 'Упакован, загрузка документов',
  ORDER_INFO_PACKED_DOCUMENTS_UPLOADED: 'Упакован, ожидает сборки',
  ORDER_INFO_IN_PACKING: 'На комплектации',
  ORDER_INFO_SHIPPED: 'Отгружен',
  ORDER_INFO_COURIER: 'На доставке',
  ORDER_INFO_DELIVERED: 'Доставлен',
  ORDER_INFO_PARTIALLY_DELIVERED_NOT_RETURNED: 'Частичная доставка - на возврате',
  ORDER_INFO_PARTIALLY_DELIVERED_RETURNED: 'Частичная доставка - возвращен',
  ORDER_INFO_RETURNED: 'Возвращён',
  ORDER_INFO_LOST: 'Утерян',
  ORDER_INFO_RETURNING: 'Возвращается',
  ORDER_INFO_AT_TAKEOUT_POINT: 'В пункте выдачи',
  ORDER_INFO_DONE: 'Доставлен',
  ORDER_INFO_CANCELED: 'Отменен',
  ORDER_INFO_WAIT_UNPACK: 'Ожидает распаковки',
  ORDER_INFO_SORT_CENTER_ARRIVED: 'Принят на СЦ',
  ORDER_INFO_SORT_CENTER_SHIPPED: 'Отгружен с СЦ',
  ORDER_INFO_SORT_CENTER_RETURNED: `Возврат на СЦ`,
  ORDER_INFO_SORT_CENTER_RETURNED_AND_SHIPPED: `Возврат отгружен с СЦ`,
  ORDER_INFO_SORT_CENTER_PARTIALLY_RETURNED: `Част. возврат на СЦ`,
  ORDER_INFO_SORT_CENTER_PARTIALLY_RETURNED_AND_SHIPPED: `Част. возврат отгружен с СЦ`,
  ORDER_INFO_SORT_CENTER_PARTIALLY_RETURNED_AND_DELIVERED: `Ожидает приёмки возврата`,
  ORDER_INFO_RETURNED_TO_CLIENT: `Возвращен клиенту напрямую`,
  ORDER_INFO_PACKING_ERROR: `Коррекция сборки`,
  ORDER_INFO_PACKING_ERROR_UPDATED: `Коррекция сборки выполнена`,
};

export const DELIVERY_TYPE_TRANSLATE = {
  COURIER: 'Курьер',
  PVZ: 'Пункт выдачи заказов',
  RUSSIAN_POST: 'Отделение',
  SELF_PICKUP: 'Самовывоз из магазина',
  B2B: 'поставка на маркетплейс',
};

export const DELIVERY_PAYMENT = [
  {
    label: 'Отправитель',
    value: 'SENDER',
  },
  {
    label: 'Получатель',
    value: 'RECEIVER',
  },
];

export const DELIVERY_SERVICES_TRANSLATE = {
  ARTIAL_DELIVERY: 'Частичная доставка',
  TRYING: 'Примерка',
  CHECK_CONTENT: 'Осмотр вложения',
  PERSONALLY_IN_HANDS: 'Лично в руки',
  DANGEROUS_CARGO: 'Опасный груз',
  VERIFY: 'Проверка состояния',
  REVERSE: 'Возврат сопроводительных документов',
  PARTIAL_DELIVERY: 'Частичная доставка',
  CONTACTLESS_DELIVERY: 'Бесконтактная доставка',
  TEMPERATURE_REGIME: 'Температурный режим',
  LIFT_TO_DOOR: 'Погрузо-разгрузочные работы на лифте',
  LIFT_TO_DOOR_MANUAL: 'Погрузо-разгрузочные работы на руках',
  DELIVERY_DATE_APPROVE: 'Согласование даты и времени доставки',
  BOX_NEEDED: 'Обрешётка',
};

export const WAREHOUSE_TYPE_TRANSLATE = {
  MANUAL: 'Свой склад',
  FULFILLMENT: 'Фулфилмент',
};

export const OPERATOR_TYPE = [
  { label: 'MANUAL', value: 'MANUAL' },
  { label: 'FULFILLMENT', value: 'FULFILLMENT' },
];

export const WAREHOUSE_ORDER_TYPE = [
  { label: 'ORDER', value: 'ORDER' },
  { label: 'NON_ORDER', value: 'NON_ORDER' },
];

export const WAREHOUSE_OPERATION_TYPE = [
  { label: 'SORT_CENTER', value: 'SORT_CENTER' },
  { label: 'STORAGE', value: 'STORAGE' },
];

export const AUTO_SYNC_INTERVAL = [
  { label: 'EVERY_10_MINUTES', value: 'EVERY_10_MINUTES' },
  { label: 'EVERY_20_MINUTES', value: 'EVERY_20_MINUTES' },
  { label: 'EVERY_30_MINUTES', value: 'EVERY_30_MINUTES' },
];

export const ORDER_TYPE = [
  { label: 'STANDARD', value: 'STANDARD' },
  { label: 'CUSTOM', value: 'CUSTOM' },
];

export const VAT_RATES = [
  { value: 'NO_VAT', label: 'Без НДС' },
  { value: 'VAT_0', label: '0%' },
  { value: 'VAT_5', label: '5%' },
  { value: 'VAT_7', label: '7%' },
  { value: 'VAT_10', label: '10%' },
  { value: 'VAT_18', label: '18%' },
  { value: 'VAT_20', label: '20%' },
];

export const PRODUCT_TYPES = [
  { value: 'SKU', label: 'Товар' },
  { value: 'PHYSICAL_SET', label: 'Комплект' },
  { value: 'SERVICE', label: 'Услуга' },
  { value: 'SUBSCRIPTION', label: 'Подписка' },
  { value: 'BUNDLE', label: 'Виртуальный набор' },
  { value: 'AD_ATTACHMENT', label: 'Доп. вложение' },
  { value: 'PACKING_MATERIAL_BOXES', label: 'Упаковочные короба' },
  { value: 'PACKING_MATERIAL_OTHER', label: 'Другие виды расходных материалов' },
  { value: 'PACKING_MATERIAL_ATTACHMENT', label: 'Доп. вложения для упаковки' },
];

export const PRODUCT_BADGES_TYPES = [
  { value: 'SKU', label: 'Товар' },
  { value: 'PHYSICAL_SET', label: 'Комплект' },
  { value: 'SERVICE', label: 'Услуга' },
  { value: 'SUBSCRIPTION', label: 'Подписка' },
  { value: 'BUNDLE', label: 'Виртуальный набор' },
  { value: 'VARIATIVE', label: 'Вариативный набор' },
  { value: 'AD_ATTACHMENT', label: 'Доп. вложение' },
];

export const SUPPLY_STATUS_TRANSLATE = {
  DRAFT: 'Черновик',
  NEW: 'Новая',
  READY_TO_TAKE_IN: 'Ожидает приемки',
  TAKE_IN_PROCESS: 'Идет приемка',
  COMPLETED: 'Принята',
  COMPLETED_WITH_DIFFERENCE: 'Принята с расхождениями',
  CANCELED: 'Отменена',
  DIFFERENCE: 'Подтвердите расхождение',
};

export const SELECTION_BY_DATE_TRANSLATE = {
  CREATED: 'По дате создания',
  COMPLETED: 'По дате приемки',
};

export const GATHER_TYPE_TRANSLATE = {
  COURIER: 'Сбор курьером',
  SELF_PICKUP: 'Самопривоз',
};

export const SHIPPING_STATUS_TRANSLATE = {
  SHIPPED: 'Отгружен',
  ARRIVED: 'Прибыл на СЦ',
  RETURNED: 'Возвращен',
  PARTIALLY_RETURNED: 'Возвращен',
};

export const DELIVERY_INFO_VISIBILITY = [
  { value: 'DISABLED', label: 'Выключен' },
  { value: 'MANAGERS_ONLY', label: 'Только менеджеры' },
  { value: 'PUBLIC', label: 'Покупатели' },
];

export const COLLECTION_FILTERS_TRANSLATE = {
  PRICE: 'Цена',
  IS_BESTSELLER: 'Бестселлер',
  IS_NOVELTY: 'Новинка',
  STOCK_AVAILABLE: 'В наличии',
  DISCOUNT_AVAILABLE: 'Со скидкой',
  BRAND: 'Бренд',
  COUNTRY_OF_ORIGIN: 'Страна',
};

export const PAYMENTS_PAYMENT_METHOD = [
  { value: 'ONLINE', label: 'online' },
  { value: 'COD_CASH', label: 'cod_cash' },
  { value: 'COD_CARD', label: 'cod_card' },
  { value: 'NO_COD', label: 'no_cod' },
  { value: 'NO_COD_NO_CONTROL', label: 'no_cod_no_control' },
];

export const PAYMENT_VISIBILITY = [
  { value: 'MANAGERS_ONLY', label: 'Только менеджеры' },
  { value: 'PUBLIC', label: 'Покупатели' },
];

export const PAYMENT_DISCOUNT_TYPE = [
  { value: 'PERCENT', label: 'В процентах' },
  { value: 'FIX', label: 'Фиксированная' },
];

export const PAYMENT_PROVIDER_TYPE = [
  { value: 'PAYU', label: 'PayU', apiPaymentProvider: 'payu', logo: logoPayu },
  { value: 'YANDEX', label: 'Яндекс.Касса', apiPaymentProvider: 'yandex', logo: logoYandex },
  { value: 'ROBOKASSA', label: 'Robokassa', apiPaymentProvider: 'robokassa', logo: logoRobokassa },
];

export const IMAGE_MAX_SIZE = 10485760;
export const OSTICKET_FILE_MAX_SIZE = 52428800;

export const ORDERS_PAGE_TABS = [
  {
    id: 'all',
    title: 'Все заказы',
    icon: 'fe-list',
  },
  {
    id: 'agreement',
    title: 'Согласование',
    icon: 'fe-phone-call',
    states: [
      'ORDER_INFO_DRAFT',
      'ORDER_INFO_NEED_CONFIRM',
      'ORDER_INFO_INSUFFICIENT_RESERVE',
      'ORDER_INFO_REQUIRE_PAYMENT',
      'ORDER_INFO_CONFIRM_HOLD',
      'ORDER_INFO_NEW',
    ],
  },
  {
    id: 'equipment',
    title: 'Комплектация',
    icon: 'fe-box',
    states: [
      'ORDER_INFO_READY_TO_PACK',
      'ORDER_INFO_IN_PACKING',
      'ORDER_INFO_PACKED',
      'ORDER_INFO_PACKED_DOCUMENTS_REQUIRED',
      'ORDER_INFO_PACKED_DOCUMENTS_UPLOADED',
    ],
  },
  {
    id: 'delivery',
    title: 'Доставка',
    icon: 'fe-truck',
    states: [
      'ORDER_INFO_SHIPPED',
      'ORDER_INFO_COURIER',
      'ORDER_INFO_AT_TAKEOUT_POINT',
      'ORDER_INFO_SORT_CENTER_SHIPPED',
      'ORDER_INFO_SORT_CENTER_ARRIVED',
    ],
  },
  {
    id: 'return',
    title: 'Возвраты',
    icon: 'fe-corner-up-left',
    states: [
      'ORDER_INFO_RETURNING',
      'ORDER_INFO_PARTIALLY_DELIVERED_NOT_RETURNED',
      'ORDER_INFO_SORT_CENTER_RETURNED',
      'ORDER_INFO_SORT_CENTER_RETURNED_AND_SHIPPED',
      'ORDER_INFO_SORT_CENTER_PARTIALLY_RETURNED',
      'ORDER_INFO_SORT_CENTER_PARTIALLY_RETURNED_AND_SHIPPED',
      'ORDER_INFO_SORT_CENTER_PARTIALLY_RETURNED_AND_DELIVERED',
    ],
  },
  {
    id: 'errors',
    title: 'Ошибки',
    icon: 'fe-bell',
    states: [],
    problems: true,
  },
];

export const SUBSCRIPTIONS_PAGE_TABS = [
  {
    id: 'all',
    title: 'Все подписки',
    icon: 'fe-list',
  },
  {
    id: 'agreement',
    title: 'Согласование',
    icon: 'fe-phone-call',
    states: [
      'ORDER_INFO_DRAFT',
      'ORDER_INFO_NEED_CONFIRM',
      'ORDER_INFO_INSUFFICIENT_RESERVE',
      'ORDER_INFO_REQUIRE_PAYMENT',
      'ORDER_INFO_CONFIRM_HOLD',
      'ORDER_INFO_NEW',
    ],
  },
];

export const DOCUMENTS_PAGE_TABS = [
  {
    id: '',
    title: 'Все',
  },
  {
    id: 'MX1',
    title: 'МХ-1',
  },
  {
    id: 'TORG2',
    title: 'ТОРГ-2',
  },
  {
    id: 'MX3',
    title: 'MX-3',
  },
];

export const COUNTRAGENT_TYPE = [
  { value: 'COMPANY', label: 'Юридическое лицо' },
  { value: 'PERSON', label: 'Физическое лицо' },
];

export const COMPANY_LEGAL_TYPE = [
  { value: 'OOO', label: 'ООО' },
  { value: 'ZAO', label: 'ЗАО' },
  { value: 'AO', label: 'АО' },
  { value: 'PAO', label: 'ПАО' },
  { value: 'SELF_EMPLOYED', label: 'ИП' },
  { value: 'SAMO_ZANYATY', label: 'Самозанятый' },
  { value: 'COMPANY', label: 'Другое' },
];

export const IMPORT_SEARCH_FIELD_TYPES = [
  { value: 'ID', label: 'По ID' },
  { value: 'EXTID', label: 'По внешнему коду' },
  { value: 'ARTICLE', label: 'По артикулу' },
  { value: 'BARCODE', label: 'По штрихкоду' },
];

export const IMPORT_ORDER_SEARCH_FIELD_TYPES = [
  { value: 'ID', label: 'По ID' },
  { value: 'EXTID', label: 'По внешнему коду' },
  { value: 'ARTICLE', label: 'По артикулу' },
  { value: 'BARCODE', label: 'По штрихкоду' },
];

export const IMPORT_METHODS = [
  {
    label: 'Создавать и обновлять',
    value: 'CREATE',
    // description: 'При ручном заполнении товары добавляются из общего списка'
  },
  {
    label: 'Обновлять и не создавать новые',
    value: 'UPDATE',
    // description: 'При автоматическом заполняются по заданным правилам'
  },
];

//ВАЖНО! Чтобы нормально работали файлы в клиенте нужно в настройках osTicket Система/Параметры вложений отключить Login required
export const OSTICKET_PROXY =
  process.env.REACT_APP_OSTICKET_PROXY === undefined ? true : +process.env.REACT_APP_OSTICKET_PROXY;
export const OSTICKET_HOST = process.env.REACT_APP_OSTICKET_HOST || HOST;
export const OSTICKET_API_KEY = process.env.REACT_APP_OSTICKET_API_KEY || '';
export const OSTICKET_ROOT_USER = process.env.REACT_APP_OSTICKET_ROOT_USER || '';

//Доступ к локальной копии osTicket без прокси.
/*export const OSTICKET_PROXY = false;
export const OSTICKET_HOST = 'http://osticket';
export const OSTICKET_API_KEY = '411F58FCF6FC734F2B9D83948C73D546';
export const OSTICKET_ROOT_USER = 'slava-sh@yandex.ru';*/

//По умолчанию цвет secondary
export const OSTICKET_STATUS_COLORS = [
  { label: 'Новый', value: 'light' },
  { label: 'В работе', value: 'warning' },
  { label: 'Тех.работа', value: 'warning' },
  { label: 'Открыт повторно', value: 'danger' },
  { label: 'Проблема решена', value: 'success' },
  { label: 'Закрыт', value: 'success' },
];

export const TICKET_THANKS_MESSAGE = 'Спасибо, проблема решена';

export const OSTICKET_RATE_ITEMS = [
  { value: 'Вопрос не решен', iconClass: 'fe-x-square', isLike: false },
  { value: 'Стиль общения', iconClass: 'fe-users', isLike: false },
  { value: 'Удобство сервиса', iconClass: 'fe-message-circle', isLike: false },
  { value: 'Вопрос решен', iconClass: 'fe-check-square', isLike: true },
  { value: 'Стиль общения', iconClass: 'fe-heart', isLike: true },
  { value: 'Быстрое обслуживание', iconClass: 'fe-zap', isLike: true },
];

export const OSTICKET_SELECT_NETHODS = [
  { label: 'Дата создания', value: 'created' },
  { label: 'Дата закрытия', value: 'closed' },
];

export const TAG_COLORS = [
  {
    id: 'COLOR_01',
    code: '#f2445e',
    color: '#fffafa',
  },
  {
    id: 'COLOR_02',
    code: '#1ebbde',
    color: '#fffafa',
  },
  {
    id: 'COLOR_03',
    code: '#15b696',
    color: '#fffafa',
  },
  {
    id: 'COLOR_04',
    code: '#f8b239',
    color: '#fffafa',
  },
  {
    id: 'COLOR_05',
    code: '#3777d9',
    color: '#fffafa',
  },
  {
    id: 'COLOR_06',
    code: '#f6629d',
    color: '#fffafa',
  },
  {
    id: 'COLOR_07',
    code: '#09022a',
    color: '#fffafa',
  },
  {
    id: 'COLOR_08',
    code: '#914ae7',
    color: '#fffafa',
  },
  {
    id: 'COLOR_09',
    code: '#5c0a13',
    color: '#fffafa',
  },
  {
    id: 'COLOR_10',
    code: '#fee22e',
    color: '#2a2a2a',
  },
  {
    id: 'COLOR_11',
    code: '#2a2a2a',
    color: '#fffafa',
  },
  {
    id: 'COLOR_12',
    code: '#2a2a2a',
    color: '#fffafa',
  },
];

export const badgesStyle = {
  ORDER_INFO_DRAFT: {
    background: 'linear-gradient(90deg, rgba(252,253,253,1) 0%, rgba(248,249,249,1) 100%)',
    borderColor: '#fbfcfd',
    color: '#7d7f80',
  },
  ORDER_INFO_NEW: {
    background: 'linear-gradient(90deg, rgba(236,236,236,1) 0%, rgba(227,227,229,1) 100%)',
    borderColor: '#d8d8da',
    color: '#3b3c40',
  },
  ORDER_INFO_NEED_CONFIRM: {
    background: 'linear-gradient(90deg, rgba(236,236,236,1) 0%, rgba(227,227,229,1) 100%)',
    borderColor: '#d8d8da',
    color: '#3b3c40',
  },
  ORDER_INFO_INSUFFICIENT_RESERVE: {
    background: 'linear-gradient(90deg, rgba(255,235,238,1) 0%, rgba(252,221,226,1) 100%)',
    borderColor: '#fbcfd6',
    color: '#7d2c38',
  },
  ORDER_INFO_REQUIRE_PAYMENT: {
    background: 'linear-gradient(90deg, rgba(255,247,230,1) 0%, rgba(255,236,201,1) 100%)',
    borderColor: '#c1ecf4',
    color: '#296775',
  },
  ORDER_INFO_READY_TO_PACK: {
    background: 'linear-gradient(90deg, rgba(255,247,230,1) 0%, rgba(255,236,201,1) 100%)',
    borderColor: '#fdebcd',
    color: '#806027',
  },
  ORDER_INFO_CONFIRM_HOLD: {
    background: 'linear-gradient(90deg, rgba(236,236,236,1) 0%, rgba(194,237,246,1) 100%)',
    borderColor: '#c1ecf4',
    color: '#3b3c40',
  },
  ORDER_INFO_PACKED: {
    background: 'linear-gradient(90deg, rgba(255,247,230,1) 0%, rgba(255,236,201,1) 100%)',
    borderColor: '#fdebcd',
    color: '#806027',
  },
  ORDER_INFO_IN_PACKING: {
    background: 'linear-gradient(90deg, rgba(255,247,230,1) 0%, rgba(255,236,201,1) 100%)',
    borderColor: '#fdebcd',
    color: '#806027',
  },
  ORDER_INFO_SHIPPED: {
    background: 'linear-gradient(90deg, rgba(243,243,243,1) 0%, rgba(232,225,244,1) 100%)',
    borderColor: '#dbd0ee',
    color: '#422d65',
  },
  ORDER_INFO_COURIER: {
    background: 'linear-gradient(90deg, rgba(237,232,246,1) 0%, rgba(230,221,247,1) 100%)',
    borderColor: '#dbd0ee',
    color: '#422d65',
  },
  ORDER_INFO_DELIVERED: {
    background: 'linear-gradient(90deg, rgba(216,244,238,1) 0%, rgba(168,241,225,1) 100%)',
    borderColor: '#b7e2d9',
    color: '#5e827a',
  },
  ORDER_INFO_PARTIALLY_DELIVERED_NOT_RETURNED: {
    background: 'linear-gradient(90deg, rgba(216,244,238,1) 0%, rgba(168,241,225,1) 100%)',
    borderColor: '#b7e2d9',
    color: '#5e827a',
  },
  ORDER_INFO_PARTIALLY_DELIVERED_RETURNED: {
    background: 'linear-gradient(90deg, rgba(216,244,238,1) 0%, rgba(168,241,225,1) 100%)',
    borderColor: '#b7e2d9',
    color: '#5e827a',
  },
  ORDER_INFO_RETURNED: {
    background: 'linear-gradient(90deg, rgba(255,235,238,1) 0%, rgba(252,221,226,1) 100%)',
    borderColor: '#fbcfd6',
    color: '#7d2c38',
  },
  ORDER_INFO_LOST: {
    background: 'linear-gradient(90deg, rgba(255,235,238,1) 0%, rgba(252,221,226,1) 100%)',
    borderColor: '#fbcfd6',
    color: '#7d2c38',
  },
  ORDER_INFO_RETURNED_TO_CLIENT: {
    background: 'linear-gradient(90deg, rgba(216,244,238,1) 0%, rgba(168,241,225,1) 100%)',
    borderColor: '#b7e2d9',
    color: '#5e827a',
  },
  ORDER_INFO_RETURNING: {
    background: 'linear-gradient(90deg, rgba(237,232,246,1) 0%, rgba(230,221,247,1) 100%)',
    borderColor: '#dbd0ee',
    color: '#422d65',
  },
  ORDER_INFO_AT_TAKEOUT_POINT: {
    background: 'linear-gradient(90deg, rgba(237,232,246,1) 0%, rgba(230,221,247,1) 100%)',
    borderColor: '#dbd0ee',
    color: '#422d65',
  },
  ORDER_INFO_DONE: {
    background: 'linear-gradient(90deg, rgba(216,244,238,1) 0%, rgba(168,241,225,1) 100%)',
    borderColor: '#b7e2d9',
    color: '#5e827a',
  },
  ORDER_INFO_CANCELED: {
    background: 'linear-gradient(90deg, rgba(252,253,253,1) 0%, rgba(248,249,249,1) 100%)',
    borderColor: '#fbfcfd',
    color: '#7d7f80',
  },
  ORDER_INFO_WAIT_UNPACK: {
    background: 'linear-gradient(90deg, rgba(252,253,253,1) 0%, rgba(252,221,226,1) 100%)',
    borderColor: '#fcdde2',
    color: '#7d7f80',
  },
  ORDER_INFO_PACKED_DOCUMENTS_REQUIRED: {
    background: 'linear-gradient(90deg, rgba(236,236,236,1) 0%, rgba(194,237,246,1) 100%)',
    borderColor: '#c1ecf4',
    color: '#3b3c40',
  },
  ORDER_INFO_PACKED_DOCUMENTS_UPLOADED: {
    background: 'linear-gradient(90deg, rgba(216,244,238,1) 0%, rgba(168,241,225,1) 100%)',
    borderColor: '#b7e2d9',
    color: '#5e827a',
  },
};

export const FEED_OFFER_NAME_FORMAT = [
  { value: 'NAME', label: 'Название товара' },
  { value: 'NAME_COLLECTION_PARENTHESES', label: 'Название товара (название коллекции)' },
  { value: 'NAME_COLLECTION_COLON', label: 'Название товара:Название коллекции' },
];

export const FEED_OFFER_YANDEX_ATTR = [
  { value: 'vendor', label: 'vendor - Производитель' },
  { value: 'vendorCode', label: 'vendorCode - Код производителя' },
  { value: 'model', label: 'model - Модель' },
  { value: 'sales_notes', label: 'sales_notes - Комментарий к товару' },
  { value: 'description', label: 'description - Описание товарного предложения' },
  { value: 'name', label: 'name - Название товарного предложения' },
  { value: 'available', label: 'available - Статус товара (в наличие/на заказ)' },
  { value: 'oldprice', label: 'oldprice - Старая цена товара' },
  { value: 'delivery', label: 'delivery - Возможность курьерской доставки' },
  { value: 'pickup', label: 'pickup - Возможность самовывоза' },
  { value: 'store', label: 'store - Возможность купить товар без предварительного заказ' },
  {
    value: 'manufacturer_warranty',
    label: 'manufacturer_warranty - Официальная гарантия производителя (да/нет)',
  },
  { value: 'country_of_origin', label: 'country_of_origin - Страна производства товара' },
  { value: 'adult', label: 'adult - Товары adult-тематики' },
  { value: 'downloadable', label: 'downloadable - Продукт можно скачать' },
  { value: 'age', label: 'age - Возрастная категория товара (годы)' },
  { value: 'param', label: 'param - Характеристика товара' },
];

export const PRICES_MOCK = {
  'Розничная цена': {
    priceCode: 'Розничная цена',
    priceName: 'Розничная цена',
    value: null,
  },
  'Цена до скидки': {
    priceCode: 'Цена до скидки',
    priceName: 'Цена до скидки',
    value: null,
  },
};

export const MOCK_DELIVERY_ITEM = {
  name: 'Доставка',
  num: 1,
  price: 0,
  quantity: 1,
  skuType: 'SERVICE',
  variantId: 'delivery',
  vatRate: 'NO_VAT',
};

export const ORDERS_EXPORT_PAGE_LABELS = {
  exportTechData: 'Технические данные',
  orderType: 'Тип заказа',
  exportItems: 'Данные по товарам',
  searchDateType: 'Метод отбора',
  exportTags: 'Выгрузить метки',
  extendedAddress: 'Выгрузить адрес по частям',
  exportPackages: 'Данные по транспортным местам',
  exportPackedItems: 'Данные по упакованным товарам',
};

export const ORDERS_EXPORT_SEARCH_DATE_TYPE_OPTIONS = [
  { label: `Дата создания`, value: `CREATE_DATE` },
  { label: `Дата отгрузки`, value: `TAKEOUT_DATE` },
  { label: `Дата доставки`, value: `DELIVERY_DATE` },
  { label: 'Дата возврата', value: 'RETURN_DATE' },
];

export const NOTIFICATION_TYPES = {
  PURCHASE_CREATED: 'Поставка создана',
  PURCHASE_EXPORTED_FF: 'Поставка выгружена',
  PURCHASE_EXPORT_FF_ERROR: 'Поставка - ошибка при выгрузке',
  PURCHASE_TAKE_IN_PROCESS: 'Поставка в процессе приемки',
  PURCHASE_DIFFERENCE: 'Поставка не принята, есть расхождения',
  PURCHASE_COMPLETED: 'Поставка успешно принята',
  PURCHASE_COMPLETED_WITH_DIFFERENCE: 'Поставка принята с расхождениями',
  PURCHASE_COMPLETED_WITH_BRAK: 'Поставка принята с браком',
  ORDER_CREATED_FROM_CHECKOUT: 'Заказ оформлен через умную корзину',
  ORDER_CREATED_FROM_ESHOP: 'Заказ оформлен по интеграции',
  ORDER_CREATED_FROM_PRIVATE_API: 'Заказ оформлен в личном кабинете',
  ORDER_CREATED_FROM_MARKETPLACE: 'Заказ оформлен с маркетплейса',
  ORDER_ONLINE_PAID_OK: 'Заказ успешно оплачен',
  ORDER_CREATE_ERROR: 'Заказ создан с ошибкой',
  ORDER_INSUFFICIENT_RESERVE: 'Заказ - не хватает резервов',
  ORDER_EXPORT_FF_ERROR: 'Заказ - ошибка при выгрузке на фулфилмент',
  ORDER_IN_PACKING: 'Заказ на сборке',
  ORDER_PACKED_DOCUMENTS_REQUIRED: 'Заказ упакован, требуется загрузка документов',
  ORDER_PACKED: 'Заказ упакован',
  ORDER_SHIPPED: 'Заказ отгружен',
  ORDER_IN_DELIVERY: 'Заказ на доставке',
  ORDER_AT_TAKEOUT_POINT: 'Заказ доставлен в пвз/отделение',
  ORDER_DONE: 'Заказ выполнен',
  ORDER_RETURNING: 'Заказ возвращается',
  ORDER_RETURNED: 'Заказ возвращен',
  ORDER_RETURNED_DEFECTIVE: 'Заказ возвращен на брак',
  ORDER_RETURNED_AS_CLAIM: 'Заказ возвращен по рекламации',
  PREPAID_ORDER_RETURNED: 'Возврат предоплаченного заказа (кроме МП)',
  ORDER_RETURNED_AS_CLAIM_WITHOUT_MARKETPLACES: 'Заказ возвращён по рекламации (кроме МП)',
  PREPAID_ORDER_CANCELED_WITHOUT_MARKETPLACES: 'Отмена предоплаченного заказа (кроме МП)',
  ORDER_DELIVERY_VEHICLE_INFO_CHANGED:
    'Заказ — Появилась информация доставки о водителе и транспортном средстве',
  ORDER_FBO_LAMODA_SHIPPED:
    'Формируется отгрузка на Lamoda. Не забудьте загрузить УПД по ЭДО. Обратите внимание, что номер поставки в ЛК Lamoda должен совпадать с номером поставки в УПД',
};

export const NOTIFICATION_CHANNELS = {
  EMAIL: 'email',
};

export const PHYSICAL_SET_ORDER_ACTION_TYPES = [
  {
    label: 'Комплектация',
    value: 'ASSEMBLY',
  },
  {
    label: 'Разукомплектация',
    value: 'DISASSEMBLY',
  },
];

export const FINANCES_THEAD_ITEMS = {
  EXPENSE: [
    {
      title: 'Дата',
    },
    {
      title: 'Операции и документы',
    },
    {
      title: 'Оказано услуг',
      label: 'Всего',
      class: 'right',
    },
    {
      title: 'Баланс',
      class: 'right',
    },
    {
      title: '',
    },
  ],
  PAYMENT: [
    {
      title: 'Дата',
    },
    {
      title: 'Операции и документы',
    },
    {
      title: 'Баланс',
      class: 'right',
    },
    {
      title: '',
    },
  ],
  BILL: [
    {
      title: 'Дата',
    },
    {
      title: 'Операции и документы',
    },
    {
      title: 'Статус',
    },
    {
      title: 'Сумма',
      class: 'right',
    },
    {
      title: '',
    },
  ],
  REPORT: [
    {
      title: 'Дата',
    },
    {
      title: 'Операции и документы',
    },
    {
      title: 'Сумма',
      class: 'right',
    },
    {
      title: '',
    },
  ],
};

export const FINANCES_TABS = [
  {
    title: 'Взаиморасчеты',
    value: 'EXPENSE',
  },
  {
    title: 'Счета',
    value: 'BILL',
  },
  {
    title: 'Акты',
    value: 'REPORT',
  },
  {
    title: 'Поступления',
    value: 'PAYMENT',
  },
];

export const SINGLE_BILL_THEAD_ITEMS = [
  {
    title: '#',
    align: 'left',
    colSpan: 1,
  },
  {
    title: 'Товары (работы, услуги)',
    align: 'left',
    colSpan: 3,
  },
  {
    title: 'Кол-во',
    align: 'right',
    colSpan: 1,
  },
  {
    title: 'Ед.',
    align: 'left',
    colSpan: 1,
  },
  {
    title: 'Цена',
    align: 'right',
    colSpan: 1,
  },
  {
    title: 'Сумма',
    align: 'right',
    colSpan: 1,
  },
];

export const ITEMS_PAGE_TABS = [
  {
    id: 'all',
    title: 'Все',
  },
  {
    id: 'items',
    title: 'Товары',
  },
  {
    id: 'sets',
    title: 'Комплекты',
  },
  {
    id: 'virtualSets',
    title: 'Виртуальные наборы',
  },
  {
    id: 'consumables_boxes',
    title: 'Расходные материалы и допвложения',
  },
];

export const EXTRA_ITEMS_PAGE_TABS = [
  //Сделано, для подбора дополнительных под-элементов
  {
    id: 'all',
    title: 'Все',
  },
  {
    id: 'items',
    title: 'Товары',
  },
  {
    id: 'sets',
    title: 'Комплекты',
  },
  {
    id: 'virtualSets',
    title: 'Виртуальные наборы',
  },
  {
    id: 'consumables_boxes',
    title: 'Расходные материалы и допвложения',
  },
  {
    id: 'consumables_other',
    title: 'Расходные материалы и допвложения',
  },
  {
    id: 'consumables_attachment',
    title: 'Расходные материалы и допвложения',
  },
  {
    id: 'common_materials',
    title: 'Расходные материалы и допвложения',
  },
];

export const ITEMS_TYPES = [
  {
    value: 'all',
    label: 'Все',
  },
  {
    value: 'items',
    label: 'Товары',
  },
  {
    value: 'sets',
    label: 'Комплекты',
  },
  {
    value: 'virtualSets',
    label: 'Виртуальные наборы',
  },
  {
    value: 'subscription',
    label: 'Подписка',
  },
  {
    value: 'services',
    label: 'Услуги',
  },
  {
    value: 'attachments',
    label: 'Доп. вложения',
  },
];

export const ITEMS_FILTER_TYPES = {
  items: 'SKU',
  sets: 'PHYSICAL_SET',
  virtualSets: 'BUNDLE',
  subscription: 'SUBSCRIPTION',
  services: 'SERVICE',
  attachments: 'AD_ATTACHMENT',
  consumables_boxes: 'PACKING_MATERIAL_BOXES',
  consumables_other: 'PACKING_MATERIAL_OTHER',
  consumables_attachment: 'PACKING_MATERIAL_ATTACHMENT',
  common_materials: 'COMMON_PACKING_MATERIAL',
};

export const EXTRA_FILTER_TYPES = {
  consumables_boxes: 'PACKING_MATERIAL_BOXES',
  consumables_other: 'PACKING_MATERIAL_OTHER',
  consumables_attachment: 'PACKING_MATERIAL_ATTACHMENT',
  common_materials: 'COMMON_PACKING_MATERIAL',
};

export const ITEMS_BADGES = {
  PHYSICAL_SET: {
    backgroundColor: '#66C98E',
  },
  SUBSCRIPTION: {
    backgroundColor: '#F7B84B',
  },
  BUNDLE: {
    backgroundColor: '#35BAFD',
  },
  SERVICE: {
    backgroundColor: '#7e57c3',
  },
  VARIATIVE: {
    backgroundColor: '#3341BF',
  },
  AD_ATTACHMENT: {
    backgroundColor: '#E8E8E8',
    color: '#737373',
  },
};

export const PHYSICAL_SET_STATUS_TRANSLATE = {
  NEW: 'Новый',
  IN_PROCESS: 'В работе',
  DONE: 'Завершено',
  CANCELED: 'Отмена',
};

export const PHYSICAL_SET_STATUS_STYLES = {
  NEW: {
    background: '#6c757d',
    color: '#fff',
  },
  IN_PROCESS: {
    background: '#f7b84b',
    color: '#fff',
  },
  DONE: {
    background: '#1abc9c',
    color: '#fff',
  },
  CANCELED: {
    background: '#f1556c',
    color: '#fff',
  },
};

export const AD_ATTACHMENTS_CONDITIONS_OPTIONS = [
  {
    value: 'deliveries',
    label: 'Каналы доставки',
  },
];

export const PRODUCT_CHANGES_PER_PAGE_SELECT_OPTIONS = [
  { value: 10, label: 10 },
  { value: 30, label: 30 },
  { value: 50, label: 50 },
];

export const showExpirationDate = (currentOrder) => {
  return (
    [
      'ORDER_INFO_DRAFT',
      'ORDER_INFO_NEW',
      'ORDER_INFO_NEED_CONFIRM',
      'ORDER_INFO_INSUFFICIENT_RESERVE',
      'ORDER_INFO_REQUIRE_PAYMENT',
      'ORDER_INFO_READY_TO_PACK',
      'ORDER_INFO_CONFIRM_HOLD',
      // 'ORDER_INFO_PACKED',
    ].indexOf(currentOrder.status) !== -1
  );
};

export const DELIVERY_SELECT_MOCK = [
  { value: 'DIRECT_CONTRACT', label: 'Прямой договор' },
  { value: 'AGGREGATOR_CONTRACT', label: 'Договор с агрегатором' },
  { value: 'SELF_PICKUP_WAREHOUSE', label: 'Самовывоз' },
  { value: 'OWN_COURIER', label: 'Свой курьер' },
];

export const CORRECTION_MODS = {
  LIST: 'CORRECTIONS_LIST',
  ADD: 'CORRECTION_ADD',
  EDIT: 'CORRECTION_EDIT',
  INFO: 'CORRECTION_INFO',
};

export const DELIVERY_INFO_MODS = {
  LIST: 'DELIVERY_INFO_LIST',
  ADD: 'DELIVERY_INFO_ADD',
  EDIT: 'DELIVERY_INFO_EDIT',
  INFO: 'DELIVERY_INFO_INFO',
};

export const WAREHOUSE_INFO_MODS = {
  LIST: 'WAREHOUSE_INFO_LIST',
  ADD: 'WAREHOUSE_INFO_ADD',
  EDIT: 'WAREHOUSE_INFO_EDIT',
  INFO: 'WAREHOUSE_INFO_INFO',
};

export const IMPORTS_PAGE_TABS = [
  {
    id: 'products',
    title: 'Товары',
  },
  {
    id: 'chestny_znak',
    title: 'Честный знак',
  },
];

export const TEST_ORDER_SCENARIO = [
  { label: 'Не выбран', value: false },
  { label: '1. Подготовка заказа к отгрузке', value: '1' },
  { label: '2. Распределение по двум грузовым местам', value: '2' },
  { label: '3. Отмена заказа из-за повреждения товаров', value: '3' },
  { label: '4. Отмена заказа по инициативе покупателя', value: '4' },
  { label: '5. Заказ с промокодом', value: '5' },
  { label: '6. Заказ от организации', value: '6' },
];

export const WAREHOUSE_TYPES = [
  {
    label: 'Фулфилмент',
    value: 'FULFILLMENT',
  },
  {
    label: 'Свой склад',
    value: 'MANUAL',
  },
];

export const WAREHOUSE_OPERATIONS = [
  {
    label: 'Хранение',
    value: 'STORAGE',
  },
  {
    label: 'Сортировочный центр',
    value: 'SORT_CENTER',
  },
];

export const EDIT_ORDER_STATUS_OPTIONS = [
  { label: 'Не выбран', value: false },
  { label: INFO_STATUS_BAR_TRANSLATE['ORDER_INFO_SHIPPED'], value: 'ORDER_INFO_SHIPPED' },
  { label: INFO_STATUS_BAR_TRANSLATE['ORDER_INFO_DELIVERED'], value: 'ORDER_INFO_DELIVERED' },
  { label: INFO_STATUS_BAR_TRANSLATE['ORDER_INFO_RETURNED'], value: 'ORDER_INFO_RETURNED' },
];

export const DELIVERY_TYPE_OZON_FBO_OPTIONS = [
  { value: 'CREATE_TYPE_DIRECT', label: 'Прямая' },
  { value: 'CREATE_TYPE_CROSSDOCK', label: 'Кроссдок' },
];

export const DOCS_STATUSES = {
  NEW: 'NEW',
  NEED_CONFIRM: 'NEED_CONFIRM',
  SIGNED_PERFORMER: 'SIGNED_PERFORMER',
  SIGNED_CLIENT: 'SIGNED_CLIENT',
  APPROVED_CLIENT: 'APPROVED_CLIENT',
  NOT_APPROVED: 'NOT_APPROVED',
  APPROVED_AUTO: 'APPROVED_AUTO',
};

export const DOCS_STATUSES_OPTIONS = [
  { value: '', label: 'Все' },
  { value: 'NEW', label: 'Новый документ' },
  { value: 'SIGNED_PERFORMER', label: 'Подписан Исполнителем' },
  { value: 'SIGNED_CLIENT', label: 'Подписан Заказчиком' },
  { value: 'APPROVED_CLIENT', label: 'Подтвержден Заказчиком' },
  { value: 'APPROVED_AUTO', label: 'Подтвержден автоматически' },
  { value: 'NOT_APPROVED', label: 'Не согласован' },
];

export const SUBTYPES_FBO = {
  LIST: 'SUBTYPES_FBO_LIST',
  INFO: 'SUBTYPES_FBO_INFO',
  EDIT: 'SUBTYPES_FBO_EDIT',
};

export const SUPPLIES_TABS_NAME = {
  PLAN: 'planItems',
  FACT: 'factItems',
};

export const SUPPLIES_PAGE_TABS = [
  {
    id: SUPPLIES_TABS_NAME.PLAN,
    title: 'Плановые товары',
  },
  {
    id: SUPPLIES_TABS_NAME.FACT,
    title: 'Фактические товары',
  },
];
